import { ELiveRecordFilter } from '@constants';
import { create } from 'zustand';

type State = {
  filter: ELiveRecordFilter;
  setFilter: (filter: ELiveRecordFilter) => void;
};

export const useLiveRecordFilterStore = create<State>(set => ({
  filter: ELiveRecordFilter.ALL,
  setFilter: (filter: ELiveRecordFilter) => set({ filter })
}));
